import { Box, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import { CloseModalButton } from "components/Button/CloseModalButton";
import { FiltroRelatorioUnidades } from "core/features/relatorios/typings/index";
import { ReservaFiltroAdv } from "core/features/reservas/typings";
import { useEffect, useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import Toolbar from "ui/components/Toolbar";
import SelectGrupoUnidade from "ui/components/Input/SelectGrupoUnidade";
import SelectableButton from "components/Button/SelectableButton";

interface ModalFiltrosProps {
  isOpen: boolean;
  onClose: () => any;
  onSave: () => any;
  filtro: FiltroRelatorioUnidades;
  onChangeFiltro: (filtro: Partial<ReservaFiltroAdv>) => any;
  onReset: (filtro?: Partial<ReservaFiltroAdv>) => any;
}

function ModalFiltros({
  isOpen,
  onClose,
  onSave,
  filtro,
  onChangeFiltro,
  onReset,
}: ModalFiltrosProps) {
  const [localFiltro, setLocalFiltro] =
    useState<FiltroRelatorioUnidades>(filtro);

  useEffect(() => {
    setLocalFiltro(filtro);
  }, [filtro]);

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      className="antd-custom-header"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      closable={false}
      width="900px"
      centered
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onSave();
            }}
            onClose={() => {
              onReset();
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      <Box>
        <Text fontWeight="bold" mb="10px">
          Grupo(s) de unidades
        </Text>

        <Flex columnGap={2}>
          <SelectGrupoUnidade
            value={localFiltro.gruposUnidadesIds}
            onChange={(v) =>
              setLocalFiltro((state) => ({ ...state, gruposUnidadesIds: v }))
            }
            mode="multiple"
            placeholder="Todos os grupos de unidades"
          />
        </Flex>
      </Box>

      <Box mt={4}>
        <Text fontWeight="bold" mb="10px">
          Situação de adimplência
        </Text>

        <Flex columnGap={2}>
          <SelectableButton
            selected={localFiltro.situacaoAdimplencia === "adimplente"}
            onClick={() => {
              setLocalFiltro((state) => ({
                ...state,
                situacaoAdimplencia: "adimplente",
              }));
            }}
            onUnselect={() =>
              setLocalFiltro((state) => ({
                ...state,
                situacaoAdimplencia: undefined,
              }))
            }
            rounded="full"
            fontSize="14px"
          >
            Adimplente
          </SelectableButton>

          <SelectableButton
            selected={localFiltro.situacaoAdimplencia === "inadimplente"}
            onClick={() => {
              setLocalFiltro((state) => ({
                ...state,
                situacaoAdimplencia: "inadimplente",
              }));
            }}
            onUnselect={() =>
              setLocalFiltro((state) => ({
                ...state,
                situacaoAdimplencia: undefined,
              }))
            }
            rounded="full"
            fontSize="14px"
          >
            Inadimplente
          </SelectableButton>
        </Flex>
      </Box>
    </Modal>
  );
}

export default ModalFiltros;
